import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trademore",
  "use": "icon-trademore-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-trademore\">\n  <g>\n    <path d=\"M6.46036 12.4592L5.54112 11.54L9.08151 7.99961L5.54112 4.45923L6.46036 3.53999L10.92 7.99961L6.46036 12.4592Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol